// @flow
/**
 * @module Epics/categoria
 * @desc Categoria
 */

import { ActionTypes } from '../utils/constants';
import { ofType, ActionsObservable } from 'redux-observable';
import { switchMap, map, catchError } from 'rxjs/operators';
import { BaseApiService } from '../utils/BaseApiService';
import { fetchCategoriasSuccess, fetchCategoriasFailure } from '../actions';
import { of } from 'rxjs';

export function fetchCategorias(action$: ActionsObservable, store) {
  return action$.pipe(
    ofType(ActionTypes.FETCH_CATEGORIAS_REQUEST),
    switchMap(action => {
      const { marca } = action.payload;
      return BaseApiService.get(
        `/api/cotizador/tipos/?${marca ? `marca=${marca}` : ''}`
      ).pipe(
        map(response => {
          const categorias =
            response.response &&
            Object.keys(response.response.data).map(
              key => response.response.data[key]
            );
          const extraInfo = response.response?.moreExtra;
          return fetchCategoriasSuccess(categorias, extraInfo);
        }),
        catchError(
          /* istanbul ignore next  */ ({ actions = [] }) =>
            of(fetchCategoriasFailure(), ...actions)
        )
      );
    })
  );
}
